<template>
    <el-dialog :visible.sync="visible" width="450px" append-to-body title="新的里程碑 / 新的项目阶段" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <el-form :model="form" label-position="top">
            <el-form-item label="名称" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                <el-input v-model="form.name" clearable />
            </el-form-item>
            <el-form-item label="计划日期" :rules="[{ required: true, message: '必填项' }]" :error="formError.date?.toString()" prop="date">
                <el-date-picker
                    :style="{ width: '100%' }"
                    v-model="form.date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" />
            </el-form-item>
            <el-form-item label="优先级">
                <el-input-number v-model="form.sort" :precision="0" :controls="false" :style="{ width: '100%' }"></el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="Close()">取 消</el-button>
            <el-button type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
                        visible: false,
            loading: false,
            formError: {},
            form: {
                projects_id: null,
                name: null,
                sort: null,
                date: null,
            }
        }
    },
    methods: {
                Open (config) {
            if (config) {
                console.log(config)
                this.form.projects_id = config.projects_id
            }
            this.visible = true
        },
                Close() {
            this.form.projects_id = null
            this.form.name = null
            this.form.sort = null
            this.form.date = null
            this.visible = false
        },
                SubmitForm() {
            this.formError = {}
                        this.$http.post('/9api/pm/milestone/create', this.form).then(rps => {
                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        }
    }  
}
</script>